import React from 'react'
import './contact.css'
import { HiOutlineMail } from 'react-icons/hi'
import { TbBrandLinkedin } from 'react-icons/tb'
import { useRef } from 'react';
import emailjs from 'emailjs-com'
import { HiPhone } from 'react-icons/hi'

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_s40ojcs', 'template_eh9sppo', form.current, 'Kg2rhkR8J5TfgshRJ')

        e.target.reset()

            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
    };

    return (
        <section id='contact'>
            <h5>Get In Touch</h5>
            <h2>Contact Me</h2>

            <div className="container contact__container">
                <div className="contact__options">
                    <article className="contact__option">
                        <HiOutlineMail className='contact__option-icon' />
                        <h4>Email</h4>
                        <h5>ctd983@gmail.com</h5>
                        <a href="mailto:ctd983@gmail.com" target="_blank">Send a message</a>
                    </article>

                    <article className="contact__option">
                        <TbBrandLinkedin className='contact__option-icon' />
                        <h4>Linkedin</h4>
                        <h5>Andrew Tran</h5>
                        <a href="https://www.linkedin.com/in/ctd983/" target="_blank">Send a message</a>
                    </article>

                    <article className="contact__option">
                        <HiPhone className='contact__option-icon' />
                        <h4>Call to me</h4>
                        <h5>0933.243.889</h5>
                        <a href="tel:+84933243889" target="_blank">Send a message</a>
                    </article>
                </div>
                {/* End of contact options */}

                <form ref={form} onSubmit={sendEmail}>
                    <input type="text" name='name' placeholder='Plz input your name ..' required />
                    <input type="email" name='email' placeholder='Plz input your email ..' required />
                    <textarea name='message' rows="7" placeholder='Hi Andrew, ...' required></textarea>
                    <button type='submit' className='btn btn-primary'>Send Message</button>
                </form>
            </div>
        </section>
    )
}

export default Contact